import React from "react";

type AdminPageTitleProps = {
  title: string;
};

export default function AdminPageTitle({ title }: AdminPageTitleProps) {
  return (
    <section className="rounded-2xl border border-slate-800 bg-slate-900/60 p-6">
      <h2 className="text-xl font-semibold text-slate-100">{title}</h2>
    </section>
  );
}
